export default "__VITE_ASSET__DKeKbXx0__"